import React from 'react';

import { TextField, TextFieldProps } from '@material-ui/core';

import styles from './EditInput.module.scss';

export interface EditInputProps {
	errorText?: string;
	size?: 'lg' | 'md';
}

export const EditInput: React.FC<
	Omit<TextFieldProps, 'size'> & EditInputProps
> = ({
	errorText,
	inputProps,
	InputProps,
	FormHelperTextProps,
	size = 'lg',
	className,
	...rest
}) => {
	return (
		<TextField
			error={!!errorText}
			label={errorText}
			className={className}
			inputProps={{
				...inputProps,
				className: [
					inputProps?.className,
					styles['edit-input__text'],
					styles[`size-${size}`],
				].join(' '),
			}}
			InputProps={{
				...InputProps,
				className: [
					InputProps?.className,
					styles['edit-input__underline'],
				].join(' '),
			}}
			FormHelperTextProps={{
				...FormHelperTextProps,
				classes: {
					...FormHelperTextProps?.classes,
					root: [
						FormHelperTextProps?.classes?.root,
						styles['edit-input__helper-text'],
					].join(' '),
				},
			}}
			{...rest}
		/>
	);
};
